// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-grid-folder {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 10px;
  overflow-y: auto;
  justify-items: center;
}
.container-grid-folder ion-button {
  --padding-top: 4px;
  --padding-bottom: 4px;
  height: auto;
}

.image-name {
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  max-width: 80%;
  margin-top: 5px;
}

.main-container-icon {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 10px;
  height: 100%;
  overflow-y: scroll;
  width: 100%;
  justify-items: center;
}
.main-container-icon ion-button {
  height: 90px;
  width: 90px;
  text-transform: uppercase;
}

.icon-folder {
  color: #f8c843;
  font-size: 50px;
}

.clickable {
  cursor: pointer;
}

.folder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666666;
  font-size: 8px;
  width: 110px;
}

.selected {
  border: 4px solid white;
  border-width: 4px 4px 4px 4px;
  box-shadow: 0 0 0 4px var(--ion-color-primary);
  border-radius: 4px;
}

.image-thumbnail {
  max-width: 40px;
  max-height: 40px;
  object-fit: contain;
}

ion-header ion-toolbar {
  --padding-bottom: 0;
}
ion-header ion-toolbar + ion-toolbar {
  --padding-top: 0;
  --padding-bottom: 16px;
}
ion-header ion-button {
  height: 30px;
  width: 30px;
  --padding-start: 0;
  --padding-end: 0;
  flex-shrink: 0;
}
ion-header ion-button ion-icon {
  color: var(--ion-color-medium-shade);
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/popup-repository-icon/popup-repository-icon.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AACF;AACE;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;AACJ;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AAAF;AAEE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;AAAJ;;AAIA;EACE,cAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;AADF;;AAIA;EACE,uBAAA;EACA,6BAAA;EACA,8CAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAKE;EACE,mBAAA;AAFJ;AAII;EACE,gBAAA;EACA,sBAAA;AAFN;AAME;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAJJ;AAMI;EACE,oCAAA;EACA,eAAA;AAJN","sourcesContent":[".container-grid-folder {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n  padding: 10px;\n  overflow-y: auto;\n  justify-items: center;\n\n  ion-button {\n    --padding-top: 4px;\n    --padding-bottom: 4px;\n    height: auto;\n  }\n}\n\n.image-name {\n  text-align: center;\n  white-space: normal;\n  word-wrap: break-word;\n  max-width: 80%;\n  margin-top: 5px;\n}\n\n.main-container-icon {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n  padding: 10px;\n  height: 100%;\n  overflow-y: scroll;\n  width: 100%;\n  justify-items: center;\n\n  ion-button {\n    height: 90px;\n    width: 90px;\n    text-transform: uppercase;\n  }\n}\n\n.icon-folder {\n  color: #f8c843;\n  font-size: 50px;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.folder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #666666;\n  font-size: 8px;\n  width: 110px;\n}\n\n.selected {\n  border: 4px solid white;\n  border-width: 4px 4px 4px 4px;\n  box-shadow: 0 0 0 4px var(--ion-color-primary);\n  border-radius: 4px;\n}\n\n.image-thumbnail {\n  max-width: 40px;\n  max-height: 40px;\n  object-fit: contain;\n}\n\nion-header {\n  ion-toolbar {\n    --padding-bottom: 0;\n\n    &+ion-toolbar {\n      --padding-top: 0;\n      --padding-bottom: 16px;\n    }\n  }\n\n  ion-button {\n    height: 30px;\n    width: 30px;\n    --padding-start: 0;\n    --padding-end: 0;\n    flex-shrink: 0;\n\n    ion-icon {\n      color: var(--ion-color-medium-shade);\n      font-size: 22px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
